// extracted by mini-css-extract-plugin
export var option = "_5t-0";
export var optionCard = "_5t-f";
export var optionContent = "_5t-g";
export var optionIcon = "_5t-i";
export var optionIconBox = "_5t-h";
export var optionLabel = "_5t-j";
export var optionPill = "_5t-m";
export var optionPillBadge = "_5t-p";
export var optionPillIcon = "_5t-n";
export var optionPillLabel = "_5t-o";
export var optionRadio = "_5t-k";
export var optionRadioInner = "_5t-l";
export var optionReveal = "_5t-2";
export var optionRevealDelay0 = "_5t-3";
export var optionRevealDelay1 = "_5t-4";
export var optionRevealDelay10 = "_5t-d";
export var optionRevealDelay11 = "_5t-e";
export var optionRevealDelay2 = "_5t-5";
export var optionRevealDelay3 = "_5t-6";
export var optionRevealDelay4 = "_5t-7";
export var optionRevealDelay5 = "_5t-8";
export var optionRevealDelay6 = "_5t-9";
export var optionRevealDelay7 = "_5t-a";
export var optionRevealDelay8 = "_5t-b";
export var optionRevealDelay9 = "_5t-c";
export var optionSelected = "_5t-1";